import { ImageInternalInfo } from 'models';

export const getImageResolution = (internalImageInfo: DeepIMap<ImageInternalInfo>): string => {
  const height = internalImageInfo && internalImageInfo.get('height');
  const width = internalImageInfo && internalImageInfo.get('width');

  return (width && height) ? `${width} x ${height}px` : 'N/A';
};
